import { Box, Chip, Fade, Stack, Tooltip } from '@mui/material';
import styled from '@emotion/styled/macro';

export const StyledFurnitureImage = styled(Box, {
  shouldForwardProp: prop => !['bg'].includes(prop)
})`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-size: 100%;
  background-image: ${({ bg }) => `url(${bg})`};
`;

export const StyledFurnitureActions = styled(Stack)`
  position: relative;
  z-index: 1;
  align-items: start;
  opacity: 0;
  color: #000;
  transition: opacity 250 ease-out;
  font-size: 0.8em;
`;

export const StyledActionButton = styled(Box)`
  color: #fff;
  background: #000;
  line-height: 0.5em;
  padding: 0.5em;
  border-radius: 1em;
  cursor: pointer;
`;

export const StyledBoundingBox = styled(Box)`
  pointer-events: initial;
  position: absolute;
  left: 0;
  bottom: 0;

  &:before {
    content: "";
    position: absolute;
    width: 100%;
    height: 100%;
    border: 2px solid ${({theme}) => theme.palette.primary.main};
    border-radius: 10px;
    padding: 10px;
    top: -10px;
    left: -10px;
    opacity: 0;
    box-shadow: 0 0 20px #fff;
    background: rgba(255,255,255,0.5);
    transition: 250ms ease-out;
  }

  svg {
    pointer-events: none;
  }

  &:active,
  &:hover {
    &:before,
    ${StyledFurnitureActions} {
      opacity: 1;
    }
  }
`

export const StyledFurniturePosInfo = styled(Box)`
  position: absolute;
  bottom: 100%;
  transform: translate3d(0, -0.5em, 0);
  left: 0;
  background: #000;
  color: #fff;
  border-radius: 4px;
  padding: 0.5em;
  line-height: 1;
`;